import createReducer from '../utils/createReducer';
import ListingActions from '../actions/listingActions';

const initialState = {};

const actionHandlers = {
    [ListingActions.FETCH_USER_DATA_SUCCESS](state, {payload}) {
        const {
            userData
        } = payload;

        const newState = Object.assign({}, state, {userData});
        return newState;
    }
};

export default createReducer(actionHandlers, initialState);
